import React, { useState } from 'react'
import Header from './Header'
import Menu from './Menu'

const Layout = ({ 
  children, 
  pageTitle = '',
  showTopPageButton = true,
  showUserInfo = true,
  showLogout = true
}) => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const closeMenu = () => {
    setMenuOpen(false)
  }

  return (
    <div className="min-h-screen bg-gray-50" data-testid="layout-container">
      {/* Header */}
      <Header 
        onMenuToggle={toggleMenu}
        pageTitle={pageTitle}
        showTopPageButton={showTopPageButton}
        showUserInfo={showUserInfo}
        showLogout={showLogout}
      />

      {/* Menu */}
      <Menu 
        isOpen={menuOpen}
        onClose={closeMenu}
      />

      {/* Main Content */}
      <main className="mx-auto px-2 sm:px-4 lg:px-8 py-4 sm:py-8" data-testid="layout-main-content">
        {children}
      </main>
    </div>
  )
}

export default Layout
